/* eslint-disable react/no-danger */
import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import { IconExternalLink } from '@/app/components/hotel-detail/common/icons';
import { RankingBoxContainer } from './styled';

type RankingBoxProps = {
  localization: Localization;
  hasPreselectedFlight?: boolean;
  variant?: 'default' | 'evolution';
};

const RankingBox = ({ localization, hasPreselectedFlight = false, variant = 'default' }: RankingBoxProps) => {
  const { t } = useTranslation();
  if (!localization.rankingLink) return null;
  return (
    <RankingBoxContainer hasPreselectedFlight={hasPreselectedFlight} variant={variant}>
      <span
        dangerouslySetInnerHTML={{
          __html: t('vacation.oss.indexcollapsed.ranking').replace(
            /__(.*?)__/g,
            `<a href=${localization.rankingLink} target="_blank" rel="noreferrer" title="$1">$1</a> `
          ),
        }}
      />
      <IconExternalLink />
    </RankingBoxContainer>
  );
};

export default RankingBox;
